import { useMemo } from "react"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { MERCHANT_ADMIN_ROUTE } from "../../../../../constants/routes"
import { FetchPriceListsResponse, PriceListQuery, fetchPriceLists } from "../../priceList/priceListApi"
import { StandardTabs } from "../../../../../shared/components/tabs/StandardTabs"
import { OffersTab } from "./OffersTab"

const selectPriceLists = (data: FetchPriceListsResponse) => data?.priceLists || []

export function Offers() {
    const { merchantId } = useMerchant()
    const { l10n } = useAppLocalization()

    const { data: priceLists = [], isLoading } = useApiQuery(fetchPriceLists, {
        queryName: PriceListQuery.LIST,
        dependencies: {
            merchantId,
        },
        select: selectPriceLists,
    })

    const tabs = useMemo(
        () =>
            priceLists.map((priceList) => ({
                label: priceList.name,
                component: <OffersTab priceListId={priceList.id} />,
            })),
        [priceLists],
    )

    return (
        <>
            <LocalizedStrict id="offers-page-header" attrs={{ title: true }}>
                <PageHeader title="Offers" page={Page.MERCHANT_ADMIN_OFFERS}>
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-products-header">
                            <Breadcrumb>Products</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-offers">
                            <Breadcrumb>Offers</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            {!isLoading && priceLists.length > 0 && <StandardTabs tabs={tabs} />}
        </>
    )
}
